<template>
<div style="text-align:left;">
 <strong>Project Team</strong>
   <div>
      <b-table id="projectTeamData" style="font-size: 12px; padding-right: 0px; padding-left: 0px; min-width:1280px; min-height:400px;
		bordered  margin-left: 0px; margin-right: 0px;" sticky-header="400px" small responsive head-variant="light" :fields="d_headers"
		:items="c_projectTeamData" selectable select-mode="single" @row-selected="m_onRowSelected"	selected-variant="success">
        <template #cell(accountId)="data">
            <div class="form-group" style="width:350px;">
				<kt-select
						p_appEntKey="acct"
						id="accountId"
						:p_currentVal="data.item.account"
						:p_readOnly="p_mode=='view'"
						:p_enableCreate="false"
						@change="m_accountChange($event,data.index)">
				</kt-select>
            </div>
        </template>
       <template #cell(contractValue)="data">
		<div style="width:200px;">
			<b-input-group prepend="$" size="md" class="mb-2 mr-sm-2 mb-sm-0">
				<b-form-input
					id="contractValue"
					v-model="data.item.contractValue"
					:value="d_projectTeamData.contractValue?Number(d_projectTeamData.contractValue).toLocaleString():''"
					type="number"
					:formatter="m_numberFormat">
				</b-form-input>
			</b-input-group>
		</div>
        </template>
		<template #cell(rating)="data">
		<div style="margin-top:0px;width:150px;">
			<b-form-rating
				id="rating"
				variant="warning"
				v-model="data.item.rating"
				:value="data.item.rating"
				size="sm"
				stars=5
				inline
				:index="index"
				@change="m_handleRatingChange">
			</b-form-rating>
		</div>
        </template>
		<template #cell(comments)="data">
		<div style="width:500px;">
					<details>
						<summary class="comments"><span class="fa-layers fa-1x"><fa-icon icon="comments"/><span v-if="(data.item.comments||[]).length>0"  class="fa-layers-counter zoom"  style="background:gold">{{(data.item.comments||[]).length}}</span></span></summary>
						<div class="form-group">
							<div class="ktt-comment scrollBar">
								<b-button class="btns btn-add-cl-item" variant="outline-primary" title="Add comment" v-b-tooltip:dragbox.hover.topleft.ds500="'Add'" @click="m_addComment($event,data.index)">
									<fa-icon icon="plus" />
								</b-button>
								<b-button class="btns btn-remove-cl-item" variant="outline-danger" v-b-tooltip:dragbox.hover.topleft.ds500="'Delete'" title="Remove comment" @click="m_removeComment(data.index)">
									<fa-icon icon="trash-alt" />
								</b-button>
								<perfect-scrollbar style="margin-top: 5px; height: 20px; margin-bottom: 5px">
									<div v-for="(c) in d_projectTeamData[data.index].comments" :key="c.order" class="comment-item">
										<span style="float:left;" ><img class="small-round-profile" :src="m_profilePicURL(c.teamMemberId)" />{{c.teamMemberName}}</span>
										<span style="float:right;">{{new Date(c.addedUTC+'Z').toLocaleString()}}</span>
										<b-form-textarea size="sm" v-model="c.userComment" max-rows=2 autofocus :plaintext="!c.new"></b-form-textarea>
									</div>
								</perfect-scrollbar>
							</div>
						</div>
					</details>
		</div>
		</template>
        <template v-slot:custom-foot>
        <b-tr>
          <b-td>			
		</b-td>
        <b-td>
         </b-td>
		<b-td></b-td>
		<b-td></b-td>
        </b-tr>	
		<b-tr>
		<b-td></b-td>
		<b-td></b-td>
		<b-td></b-td>
		<b-td></b-td>
		</b-tr>	
	</template>		
	</b-table>
	</div>
	<div>
		<b-row style="margin-right:-150px;">
		<b-col>
		<b-button class="btn-add btn-add-cl-item" variant="outline-primary" title="Add role" @click="m_handleAddClick">
			<fa-icon icon="plus"/>
          Add
		</b-button>
		<b-button class="btn-save"   variant="outline-secondary" title="Save" @click="m_saveRows">
			<fa-icon icon="save" />
         Save
		</b-button>
		<b-button class="btn-delete"   variant="outline-danger" title="Delete"  :disabled="!d_deleteEnabled" @click="m_handleRemoveClick">
			<fa-icon icon="trash-alt" />
         Delete
		</b-button>
		</b-col>
		<b-col>Totals:<b>{{c_totalRows}}</b></b-col>
		<b-col></b-col>
		<b-col></b-col>
		<b-col>Contract Value:<b>${{c_calculateTotalValue}}</b></b-col>
		<b-col></b-col>
		</b-row>
	</div>
 </div>
</template>
<script>
import {fn_getProjectTeam,fn_saveProjectTeam,fn_deleteRecord} from "@/utils/api.js";
import util,{kbdpAlert,fn_profilePicURL,fn_resizeColHelper} from "@/utils/util.js";
import {userInfo,userSettings,refData} from "@/utils/ref-data.js";
import { eventBus } from "@/main";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import {Resize} from "vue-resizer";
export default {
  name: "projectTeam",
  components: {
				'perfect-scrollbar':PerfectScrollbar
				},
  props: {
	p_recInfo:Object,
  },
  data() {
    return {
		d_currentPage:1,
		d_perPage:5,
		d_selectedRow:null,
		d_selectedRowId:null,
		d_projectId:this.p_recInfo.Id,
		d_projectTeamData: [
        {
			projectTeamAccountId:null,
			projectId:this.p_recInfo.Id,
			account:null,
			accountId: null,
			rating:null,
			contractValue: null,
			comments: [],
			removed:0,
			tempId:Date.now(),
        },
      ],
      d_headers: [
        {label: "Company Name",key: "accountId",thStyle:"border-right: 0.1em solid #adb5bd;"},
		{label: "Final Contract value", key: "contractValue", thStyle:"border-right: 0.1em solid #adb5bd;"},
        {label: "Score",key: "rating", thStyle:"border-right: 0.1em solid #adb5bd;"},
		{label:"Comments",key:"comments", thStyle:"border-right: 0.1em solid #adb5bd;"}
      ],
	d_pageData:[],
	d_teamMember: userInfo.getUserInfo().teamMember,
	d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
	d_comments:[],
	d_teamMember: userInfo.getUserInfo().teamMember,
	d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
	d_deleteEnabled:null,
	};
	},
	created(){
	
		
	let params={projectId:this.d_projectId};
	
	fn_getProjectTeam(params).then((resp) =>
		{
		if (!resp.error && resp.recordData) 
				{
				console.log('Get project Team');
				console.log(resp);
				if(resp.recordData.length>0) 
					this.d_projectTeamData=resp.recordData;
				else this.m_handleAddClick;
				} 
	
           });
			
	},
	mounted() {
	
	window.addEventListener('beforeunload', 
			function (e) {
				kbdpAlert.showErr("Exit page?");
				e.preventDefault();
				e.returnValue = '';
            }
        );
	

  },
  computed: {
    c_totalRows(){return this.d_projectTeamData.filter(row=>(!row.removed||row.removed==0)).length;},
	c_projectTeamData(){
		console.log('In c_projectTeamData');
		console.log(this.d_projectTeamData);
		return this.d_projectTeamData.filter(row=>(!row.removed||row.removed==0));
	}, 
    c_calculatePageValue() {
	var total= 0;
	if(this.d_pageData.length>0){
      for (let i = 0; i < this.d_pageData.length; i++) {
        if (this.d_pageData[i].contractValue&& (!this.d_pageData[i].removed||this.d_pageData[i].removed==0))
          total += parseFloat(this.d_pageData[i].contractValue);
				}
      } 
	return total.toLocaleString();
    },
    c_calculateTotalValue() {
	var total= 0;
	if(this.d_projectTeamData.length>0){
      
      for (let i = 0; i < this.d_projectTeamData.length; i++) {
        if (this.d_projectTeamData[i].contractValue&& (!this.d_projectTeamData[i].removed||this.d_projectTeamData[i].removed==0))
          total += parseFloat(this.d_projectTeamData[i].contractValue);
			}
      }
	return total.toLocaleString('en');
    }
  },
  methods: {
	m_profilePicURL(teamMemberId){return fn_profilePicURL(teamMemberId);},
	m_accountChange(e,idx){
	
		if(e.accountId){
			this.d_projectTeamData[idx].account=e;
			this.d_projectTeamData[idx].accountId=e.accountId;
			if(!this.d_projectTeamData[idx].projectTeamAccountId){
				var params={projectId:this.d_projectId,recordData:JSON.stringify(this.d_projectTeamData[idx])};
				fn_saveData(this,params,idx);
				}
			} else { this.d_projectTeamData[idx].account=null;
					this.d_projectTeamData[idx].accountId=null;
					}

	},
     m_chgPgSize(x){
		this.d_perPage=x;
	},
	m_onRowSelected(row){if(row.length>0){
						this.d_selectedRow=row[0];
						var recordId=this.d_selectedRow.projectTeamAccountId||this.d_selectedRow.tempId;
						this.d_selectedRowId=this.d_projectTeamData.findIndex(d=>(d.projectTeamAccountId||d.tempId)==recordId);
						this.d_deleteEnabled=true;
						} else this.d_deleteEnabled=false;
	},
	m_numberFormat(value) {return value === 0 ? '' : value.toLocaleString('en');},
	m_handleRatingChange(){},
	m_saveRows(e){	
	
	var projectTeamData=this.d_projectTeamData.map(t=>{
			console.log('m_saveRows');
			console.log(this.d_projectTeamData);
			if(t.accountId)
				return {projectTeamAccountId:t.projectTeamAccountId,
						projectId:this.d_projectId,
						accountId:t.accountId,
						contractValue:t.contractValue,
						rating:t.rating
						};
		});
	var allComments=this.d_projectTeamData.map(t=>{
		if(t.comments)
			return {	recordContext:'projectTeamAccountId',
						recordId:t.projectTeamAccountId,
						comments:[...t.comments.filter(c=>c.new)]
						};
		});
	
	var params={projectId:this.d_projectId,
				comments:JSON.stringify(allComments),
				recordData:JSON.stringify(projectTeamData)
			};
			
	fn_saveData(this,params,null);
	},
    m_handleAddClick() {
		let temp = [...this.d_projectTeamData];
		temp.push({
			projectTeamAccountId:null,
			projectId:this.d_projectId,
			accountId:null,
			account:null,
			rating: null,
			contractValue: null,
			comments:[],
			removed:0,
			tempId:Date.now(),
      });
      this.d_projectTeamData =[...temp];
    },
    m_handleRemoveClick() {
			

			if(this.d_selectedRowId != null)
				fn_deleteRoutine(this,this.d_selectedRowId);

			
		},
		m_addComment(e,i){

			//var i=this.d_selectedRowId;
			let now=new Date();
			let cRow={};
			if(this.d_projectTeamData[i].comments){
				cRow = {order: this.d_projectTeamData[i].comments.length + 1, teamMemberId: this.d_teamMemberId,teamMemberName:'You', addedUTC:now, addedUTCString: now.toLocaleString(), new: true, 
						image: fn_profilePicURL(this.d_teamMemberId),comment: null};
				this.d_projectTeamData[i].comments.unshift(cRow);
			}
			else {	cRow = {order:1, teamMemberId: this.d_teamMemberId,teamMemberName:'You', addedUTC:now, addedUTCString: now.toLocaleString(), new: true, 
							image: fn_profilePicURL(this.d_teamMemberId),comment: null};
					var comments=[];
					comments.push(cRow);
					this.d_projectTeamData[i]['comments']=comments;
					}
			setTimeout(() => {
				let commentElem = $(e.target)
					.closest(".ktt-comment")
					.find(".comment-item")
					.last()
					.children("input:text");
				commentElem.focus();
			}, 100);
			
			console.log('Comments after');
			console.log(this.d_projectTeamData[i].comments);
			},
		m_removeComment(i){

			//var i=this.d_selectedRowId;;
			if(this.d_projectTeamData[i].comments[0].new)
				this.d_projectTeamData[i].comments.splice(0,1);

		},
		m_countComments(i){
		//var i=this.d_selectedRowId;
		return this.d_projectTeamData[i].comments.length;
		},
	m_resizeMD(e, col) {
			//Mouse Down Event
			if (e.button != 0) return;
			if (e.detail > 1) return;


			fn_resizeColHelper(e, col, this.d_opts).then(newWidth => {
				col.width = newWidth;
				let val = {
					_tblW: this.d_opts.width
				};

          
				this.d_cols.filter(x => x.width).forEach(x => {
					val[x.field] = x.width;
				});
				//util.fn_saveUserOpts(this.d_id, 'tableColumnWidths', val);
			});
		}
	},
  watch: {},
};

function fn_saveData(vc,params,idx) {
			console.log('idx:'+idx);
			console.log('params');
			console.log(params);
	if(idx == null) kbdpAlert.showSaving('projectTeam Data');
	fn_saveProjectTeam(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to save projectTeam Data ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {

			if(idx != null){vc.d_projectTeamData[idx].projectTeamAccountId=resp.newRecHdr.projectTeamAccountId;
			}
			else {kbdpAlert.showOk('projectTeam Data saved successfully');
				//Refresh data
				fn_getProjectTeam({projectId:vc.d_projectId})
				.then(resp => { 
								console.log('resp.recordData');
								console.log(resp.recordData);
								vc.d_projectTeamData=resp.recordData;
				});
				kbdpAlert.clear();
				}
		}
		
	})
}

function fn_deleteRoutine(vc,recId) {
    let recordLabel = vc.d_projectTeamData[recId].account.accountName;
	let projectTeamAccountId = vc.d_projectTeamData[recId].projectTeamAccountId;
	let content = {
		titleText: 'Confirm Delete',
		message1:`Are you sure you want to delete the Account ${recordLabel}?`,

	};
	let cm = util.fn_getModal_confirm(vc, content);

	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		if (!resp) return;

		kbdpAlert.showDeleting(`Project Team Account ${recordLabel}`);

		let appEntNm = 'projectTeam';
		fn_deleteRecord(appEntNm, projectTeamAccountId).then(resp => {
			if (resp.error || !resp.status) {
				kbdpAlert.showErr("Unable to delete record");
				return;
			}
			let temp = [...vc.d_projectTeamData];
			temp.splice(recId, 1);
			vc.d_projectTeamData = [...temp];
			vc.d_deleteEnabled=false;
			kbdpAlert.showOk(recordLabel + " is Deleted Successfully.");
		});
	});
}
</script>
<style scoped lang="scss">
label {
  font-weight: 600 !important;
}
*:focus {
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text {
  height: 100% !important;
  border-radius: 0.375rem 0px 0px 0.375rem !important;
}
.b-icon.bi {
  color: #ffc107 !important;
}
.table td {
  border: none !important;
}

.small-td {
  width: 100px !important;
}
.large-td {
  width: 300px !important;
}

p {
  margin-left: 20px !important;
  color: #42b983 !important;
  font-weight: 600 !important;
}

.input-group {
  width: 150px !important;
}
.team-member-item {
  width: 150px !important;

  .multiselect {
    min-height: 38px !important;
    max-height: 100% !important;
    width: 150px !important;
.multiselect__tags {
      height: 30px !important;
      border-radius: 0px !important;
    }
  }
}
.person-fill {
  height: 43px;
}

.project-cost-heading {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.btn-save{
		color:#008000;
		borders:none;
		margin-left: 0.1em;;
		margin-right: 0.1em;
}
.tableHeader{
			background-color: #6c757d;
			color: #fff;
}
.form-control {
  margin-top: 0px !important;
}
.form-control:focus {
  box-shadow: none !important;
}
.svg-inline1--fa.fa-w-14{width:0.5em !important;}
ta-end{text-align: end;}
.btns {
			border: none;
			min-width: 20px;
			text-align: right;
			padding: 0 0.2em;
			button.btn {
				font-size: 0.85em;
				padding: 0.3em 0.2em;
				margin: 0 0.1em;
				border-radius: 0.2em;
				line-height: 1em;
				opacity: 0.5;
				border: none;
				width: 30px;
			}
		}
.scrollBar {
  height:150px;
  overflow-y: scroll;
}
.zoom {
  padding: 0px;
  background-color: green;
  transition: transform .2s;
  width: 5px; //5px
  height:20px; //20px
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.2); /* IE 9 */
  -webkit-transform: scale(1.2); /* Safari 3-8 */
  transform: scale(1.2); 
}
.comment-item{
			border-bottom: solid 0.1em #dee2e6;
	}
.small-round-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
</style>
